import React, { useState, useEffect } from 'react'
import { api, formatCurrency, formatDateTime } from '../../utils/api'
import { SHOPIFY_ADMIN_URL } from '../../utils/constants'

const CSV_COLUMNS = [
  { key: 'captured_at', label: 'Captured' },
  { key: 'name', label: 'Name' },
  { key: 'email', label: 'Email' },
  { key: 'product_title', label: 'Product' },
  { key: 'shopify_product_id', label: 'Product ID' },
  { key: 'price_cents', label: 'Price' },
  { key: 'date_sold', label: 'Date Sold' },
  { key: 'status', label: 'Status' }
]

function NotifyMeProducts() {
  const [captures, setCaptures] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => { loadCaptures() }, [])

  async function loadCaptures() {
    setLoading(true)
    try {
      const res = await api.get('/api/marketing/notify-me')
      setCaptures(res.captures || [])
    } catch (error) {
      console.error('Failed to load notify-me captures:', error)
    } finally {
      setLoading(false)
    }
  }

  function exportCsv() {
    const header = CSV_COLUMNS.map(c => c.label).join(',')
    const rows = captures.map(c =>
      CSV_COLUMNS.map(col => csvCell(formatValue(col.key, c[col.key]))).join(',')
    )
    downloadCsv([header, ...rows].join('\n'), 'notify-me-captures.csv')
  }

  if (loading) return <div className="text-sm text-muted" style={{ padding: '16px 0' }}>Loading…</div>

  return (
    <div>
      <div className="filter-section">
        <div className="filter-actions-right">
          <span className="text-sm text-muted" style={{ marginRight: 12 }}>{captures.length} captures</span>
          <button className="btn btn-secondary" onClick={exportCsv} disabled={captures.length === 0}>Export CSV</button>
        </div>
      </div>

      {captures.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-title">No relist interest captured yet</div>
          <div className="empty-state-description">
            When a customer taps "Notify me if relisted" on a sold product, their details appear here.
          </div>
        </div>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>Captured</th>
              <th>Name</th>
              <th>Email</th>
              <th>Product</th>
              <th>Price</th>
              <th>Date Sold</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {captures.map(c => (
              <tr key={c.notify_capture_id}>
                <td className="text-sm">{formatDateTime(c.captured_at)}</td>
                <td>{c.name || '-'}</td>
                <td><a href={`mailto:${c.email}`}>{c.email}</a></td>
                <td>
                  <div>{c.product_title || 'Unknown product'}</div>
                  <a className="text-sm text-muted" href={`${SHOPIFY_ADMIN_URL}/products/${c.shopify_product_id}`} target="_blank" rel="noreferrer">
                    #{c.shopify_product_id}
                  </a>
                </td>
                <td>{c.price_cents != null ? formatCurrency(c.price_cents / 100) : '-'}</td>
                <td className="text-sm">{c.date_sold || '-'}</td>
                <td><span className="text-sm text-muted">{c.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}

function formatValue(key, value) {
  if (value == null) return ''
  if (key === 'price_cents') return (value / 100).toFixed(2)
  return String(value)
}

// Escape a value for CSV: wrap in quotes and double any embedded quotes.
function csvCell(value) {
  return `"${String(value).replace(/"/g, '""')}"`
}

function downloadCsv(content, filename) {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}

export default NotifyMeProducts
